
































































import CustomFieldListForm from "@/components/report/CustomFieldListForm.vue";
import { getFlagEmoji } from "@/lib/CountryCodeHelper";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { IGroupTypeEntityBase } from "@/lib/utility/group/interface/group-type-entity.interface";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { CustomFieldValue } from "@/models/custom-field-value.entity";
import { Group, IGroup } from "@/models/group.entity";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { GroupModule } from "@/store/modules/group.store";
import { PartnerModule } from "@/store/modules/partner";
import { debounce } from "debounce";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import GroupTypeCreateDialog from "../group/GroupTypeCreateDialog.vue";

@Component({
  components: {
    GroupTypeCreateDialog,
    CustomFieldListForm
  },
  filters: {
    getFlagEmoji
  }
})
export default class GroupTypeSelectionDetailComponent extends mixins(PermissionMixin) {
  @Prop()
  value!: IGroupTypeEntityBase;

  // changes are updated via value.updatePartial if true, else set into entity without backend sync
  @Prop({ default: true, type: Boolean })
  isUpdate!: boolean;

  group: IGroup | null = null;

  isLoadingGroup = false;

  isLoadingGroups = false;

  isLoadingCustomFieldValues = false;

  debounceSaveCustomFields = debounce(this.saveCustomFieldValues, 1000);

  get groups() {
    return GroupModule.filteredAndSorted;
  }

  mounted() {
    this.setGroup();
  }

  goToGroupCustomView() {
    if (!this.value.groupId) return;

    this.value.goTo(this.$router).customView();
  }

  @Watch("value.groupId")
  async setGroup() {
    this.group = null;

    const groupId = this.value.groupId;
    if (groupId) {
      this.isLoadingGroup = true;
      this.isLoadingCustomFieldValues = true;

      const group =
        GroupModule.maps.id.get(groupId)[0] ||
        (await new Group({ partnerId: this.value.partnerId, id: groupId }).fetch().catch(handleError));
      this.isLoadingGroup = false;
      this.isLoadingCustomFieldValues = false;

      this.$nextTick(() => {
        this.group = group;
      });
    }
  }

  async saveGroup() {
    if (!this.isUpdate) {
      return;
    }

    this.isLoadingGroup = true;

    try {
      const groupId = this.value.groupId;
      await this.value.updatePartial({ groupId });
    } catch (e) {
      handleError(e);
    }

    this.isLoadingGroup = false;
  }

  async saveCustomFieldValues() {
    if (!this.isUpdate) {
      return;
    }

    this.isLoadingCustomFieldValues = true;

    try {
      const values = CustomFieldValue.buildCustomFieldValuesDto(
        this.value.values?.map(v => ({ id: v.id, value: v.value, timezone: v.timezone })) ?? []
      );
      await this.value.updatePartial({ values });
    } catch (e) {
      handleError(e);
    }

    this.isLoadingCustomFieldValues = false;
  }

  async refreshGroups() {
    this.isLoadingGroups = true;
    try {
      GroupModule.setFilter([
        new PageFilterElement({
          key: "type",
          operation: PageFilterOperationEnum.EQUAL,
          value: BackendResourceEnum.INVOICE
        })
      ]);
      await GroupModule.fetchFirstPage({ partnerId: PartnerModule.partner.id });
    } catch (e) {
      handleError(e);
    }
    this.isLoadingGroups = false;
  }
}
